import React, {ReactNode} from "react";
import {Route, Redirect} from 'react-router-dom';
import {loggedIn} from "./authenticationSlice";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import Error403 from '../../components/errors/Error403';
import ToHomeButton from "../../components/ToHomeButton";
import Error500 from "../../components/errors/Error500";

interface Props {
    children: ReactNode;
    path: string;
}

const PrivateRoute = ({children, ...props}: Props) => {
    const {user} = useSelector((state: RootState) => state.authentication);
    const {error} = useSelector((state: RootState) => state.authenticationError);

    return (
        <Route
            {...props}
            render={({ location }) => {
                if (!loggedIn) {
                    // not logged in: redirect to login page.
                    return (
                        <Redirect to="/" />
                    )
                } else if (user || !error) {
                    // logged in: has user or no error
                    return children;
                } else if (error) {
                    // error while loading user
                    return <Error403 extra={<ToHomeButton/>}/>
                } else {
                    // other error
                    return <Error500 extra={ <ToHomeButton/> }/>;
                }
            }}
        />
    );
}

export default PrivateRoute;